var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ padding: '0in' })},[_c('b-button',{on:{"click":_vm.updateEvents}},[_vm._v("update events")]),_c('PleasantCalendar',{ref:"calendar",attrs:{"events":_vm.events}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }